import { lazy, Suspense, type ComponentType } from 'react'
import { Route } from 'react-router-dom'

import Page from 'src/components/Page'
import RequireSubscription from 'src/components/RequireSubscription'
import { SpinnerFullScreen } from 'src/components/Spinner'

import { CALCUL_SPEC } from './calculSpecs'

const calculLazies = Object.fromEntries(
  CALCUL_SPEC.map(s => [s.path, lazy(s.load as () => Promise<{ default: ComponentType }>)])
)

/** Per-calcul routes under `/dashboard/:path` (same route ids as `packages/web`). */
export const calculDashboardRoutes = CALCUL_SPEC.map(({ path, title }) => {
  const Comp = calculLazies[path]
  return (
    <Route
      key={path}
      path={path}
      element={
        <Suspense fallback={<SpinnerFullScreen />}>
          <Page title={title}>
            <RequireSubscription>
              <Comp />
            </RequireSubscription>
          </Page>
        </Suspense>
      }
    />
  )
})
